import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";

type DeleteLeaveTypesParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  typeIds: string[];
  colaboraInstanceId: string;
};

export const deleteLeaveTypes = async ({
  leaveTypesRepository,
  typeIds,
  colaboraInstanceId,
}: DeleteLeaveTypesParamsT) => {
  return await leaveTypesRepository.delete(typeIds, colaboraInstanceId);
};
